import React, {Component} from 'react';
import {Session, SaveDetailModel} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

const apiClient = ApiClient.getInstance();

require('datatables.net-bs4');

class savedViews extends Component {

    state = {
        orders: [],
        order: {
            header: {},
            body: []
        },
    };

    async componentDidMount() {
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let response = await apiClient.getSaveds();
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                orders: response.data,
            });
            $('#tablaSaved').DataTable({
                "paging": false,
                "info": false,
                "searching": false
            });
        }

    }

    openOrder = async (docEntry,CardCode,id) => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        let data = {
            CardCode : CardCode,
            id : id
        }
        enableSpinner(true);
        let response = await apiClient.getDataProduct2(docEntry);
        // await apiClient.updateCart(data);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
                data : data
            });

            $('#saveModal').modal('show');
            return;
        }

        showAlert({type: 'error', message: "Aviso: "+response.message})
    };

    render() {
        const {orders, order, data} = this.state;
        return (
            <div className="content-fluid">
                <SaveDetailModel order={order} data={data}/>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className="col-md-12">
                        <h3>Carritos guardados</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <table id="tablaSaved" class="table table-striped">
                            <thead>
                                <tr style={{backgroundColor: config.shoppingList.summaryList, color: "white"}}>
                                    <th scope="col">No. de carrito</th>
                                    <th scope="col">Fecha de creación</th>
                                    <th scope="col">Almacén de entrega</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Total peso neto</th>
                                    <th scope="col">Total peso bruto</th>
                                    <th scope="col">Cant. de articulos</th>
                                    <th scope="col">Cant. de unidades</th>
                                    <th scope="col">Valor total</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => {
                                    return (<tr key={index}>
                                        <th scope="row">{order.id}</th>
                                        <td>{moment(order.DateCart).format('DD-MM-YYYY')}</td>
                                        <td>{order.DirEnvio+' - '+order.Zona}</td>
                                        <td>{order.Status === '1' ? 'Pendiente' : 'Cerrado'}</td>
                                        <td>{order.Neto || '0' + ' KG'}</td>
                                        <td>{order.Bruto || '0' + ' KG'}</td>
                                        <td>{order.Articulos}</td>
                                        <td>{order.Unidades}</td>
                                        <td>S/. {order.Valor}</td>
                                        <td>
                                            <span onClick={() => this.openOrder(order.Cart,order.CardCode,order.id)}>
                                                <i className={config.icons.detail} style={{color: config.shoppingList.summaryList, paddingRight: 6}}></i>
                                                Detalle
                                            </span>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(savedViews);